export const Constant = {
  route: {
    homeBuilder: {
      dashboard: "/",
      login: "/login",
      settings: "/profile",
    },
  },
  role: {
    superModerator: "Super Moderator",
    moderator: "Moderator",
    sale: "Sale",
    homeBuilder: "Home Builder",
  },
};

export const convertToFullDateTimeString = (dateString) =>
  new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
